import React, { useEffect } from 'react'
import { AuthorTag } from '../extra/AuthorTag'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'

export const TopAuthorsSection = ({ nr }: { nr: number }) => {
  const { topAuthors, loadAuthors } = useArticleTemplate()

  useEffect(loadAuthors, [loadAuthors])

  return (
    <div className='flex flex-col gap-6 lg:gap-10'>
      <h2 className='font-bold text-lg md:text-2xl lg:text-[32px] text-[#001A3D]'>
        Top authors
      </h2>

      <div className='flex flex-col gap-4'>
        {topAuthors.slice(0, nr)?.map((author, idx) => (
          <AuthorTag
            key={'Author' + idx}
            author={author}
            occupation={false}
            pictureDimension='w-[40px] h-[40px] lg:w-[80px] lg:h-[80px]'
            userNameClassName='text-sm lg:text-lg font-medium lg:font-bold pb-1 lg:pb-2'
            occupationClassName='text-xs lg:text-sm font-medium'
            tagClassName='gap-[16px] text-left'
          />
        ))}
      </div>
    </div>
  )
}
